import React from "react";

export default function SelectCustomerModal({ open, phone, matches = [], onClose, onSelect }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4">
      <div className="w-full max-w-2xl rounded-2xl bg-slate-900 border border-slate-700 shadow-xl">
        <div className="p-5 border-b border-slate-700 flex items-start justify-between gap-4">
          <div>
            <h2 className="text-xl font-bold text-white">Escolher utente</h2>
            <p className="text-sm text-slate-300 mt-1">
              O telefone <span className="font-semibold text-white">{phone}</span> está associado a{" "}
              <span className="font-semibold text-white">{matches.length}</span> pessoas. Escolhe para quem é.
            </p>
          </div>

          <button
            onClick={onClose}
            className="text-slate-300 hover:text-white px-3 py-1 rounded-lg border border-slate-700"
          >
            Fechar
          </button>
        </div>

        <div className="p-5 max-h-[60vh] overflow-auto">
          <div className="space-y-2">
            {matches.map((c) => (
              <button
                key={c.id}
                onClick={() => onSelect(c)}
                className="w-full text-left rounded-xl border border-slate-700 bg-slate-950 hover:bg-slate-800 px-4 py-3 transition"
              >
                <div className="flex items-center justify-between gap-3">
                  <div>
                    <div className="text-white font-semibold">{c.name || "(Sem nome)"}</div>
                    <div className="text-sm text-slate-300 mt-1">
                      <span className="mr-3">
                        NIF: <span className="text-slate-100">{c.nif || "—"}</span>
                      </span>
                      <span>
                        Email: <span className="text-slate-100">{c.email || "—"}</span>
                      </span>
                    </div>
                  </div>
                  <div className="text-xs text-slate-400">{c.is_active ? "Activo" : "Inactivo"}</div>
                </div>
              </button>
            ))}
          </div>
        </div>

        <div className="p-5 border-t border-slate-700 text-xs text-slate-400">
          Nota: o sistema pergunta sempre, mesmo que escolhas agora.
        </div>
      </div>
    </div>
  );
}
